/* «Помощь». Оболочка — экран React: колонка #help и пустые листы поддержки и STEOS ID.
   Колонку отдаёт prepare() один раз. Дальше раздел сам меняет узлы, и React этот кадр не перерисовывает.
   Листы внутри страницы, вне колонки: их рамка — .view, как у прототипа. */
import { useLayoutEffect, useState } from 'react';
import { helpApi } from './module';
import { uiText, useAccountLocale } from '../../i18n';

export function Help() {
  /* язык профиля: подпись листа поддержки — на нём (колонку и листы раздел перерисовывает сам по steos:locale) */
  useAccountLocale();
  const api = helpApi();
  const [m] = useState(() => api.prepare());
  useLayoutEffect(() => {
    api.attach();
  }, [api]);
  return (
    <div className="pg stp" id="help">
      <div className="stp-in" dangerouslySetInnerHTML={{ __html: m.body }} />
      <div className="bscrim" id="hpSheetScrim" data-bsheet-x="" />
      <aside className="side bsheet" id="hpSheet" role="dialog" aria-label={uiText('Поддержка')} aria-hidden="true" />
      <div className="bscrim" id="bcSidScrim" data-bsheet-x="" />
      <aside className="side bsheet" id="bcSid" role="dialog" aria-label="STEOS ID" aria-hidden="true" />
    </div>
  );
}
